module.exports = __webpack_public_path__ + "img/star1red.afe033b5.png";